import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '../../utils/mediaQueries';
import { FocusRingVariants } from '../Button';
import { CloseButton } from '../IconButton';
import Text from '../Text';

export { default as Button } from '../Button';

export const Message = styled.div`
	margin: 0;
`;

export const Body = styled(Text).attrs({
	el: 'p',
	size: 1,
	color: 'gray7',
})``;

export const Header = styled(Text).attrs({
	el: 'h2',
	size: 1,
	lineHeight: 1,
	color: 'gray7',
})``;

export const Banner = styled.div.attrs({ role: 'dialog' })`
	background-color: ${palette('gray0')};
	border-top: 1px solid ${palette('gray3')};
	left: 0;
	position: fixed;
	bottom: 0;
	transition: 300ms ease-in-out;
	z-index: 998;
	width: 100%;
	padding: 1.5rem 1rem;
`;

export const Content = styled.div`
	display: flex;
	max-width: 480px;
	margin: 0 auto;
	flex-direction: column;

	${minWidth('desktop')} {
		max-width: 960px;
		flex-direction: row;
	}

	${minWidth('desktopLarge')} {
		max-width: 1168px;
	}

	a {
		color: ${palette('blue3')};
		text-decoration: underline;
	}
`;

export const ExitIconWrapper = styled.div`
	align-items: center;
	display: flex;
	margin-left: auto;
`;

export const ExitIcon = styled(CloseButton).attrs<
	{ $isDark?: boolean },
	Pick<Parameters<typeof CloseButton>[0], 'color' | 'focusRingVariant'>
>(props => ({
	color: props.$isDark ? 'white' : 'gray6',
	focusRingVariant: props.$isDark ? FocusRingVariants.Light : FocusRingVariants.Dark,
}))<{
	$isDark?: boolean;
}>`
	padding: 0;
`;
